export default { 
    title: 'Radicaciones',
    addSettlementShortLabel: 'Nueva',
    addSettlement: 'Crear radicación',
    filterLabel: 'Filtrar por',
    resultLabel: '{result} resultado | {result} resultados',
    lastUpdateLabel: 'Última actualización: {datetime}',
    orderLabel: 'Ordenar por',
    loadingDataLabel: 'Obteniendo Radicaciones',
    emptyDataLabel: 'No se encontraron resultados',
    tryAgainLabel: 'Intente buscando otro término o ',
    paginationSizeLabel: 'Resultados/página',
    cleanFilters: 'limpiando los filtros',
    filtersAppliedLabel: ' aplicados',
    sponsorSettlement: 'En proceso',
    status: {
        inProgress: 'En progreso',
        completed: 'Pagado',
        sentToSponsor: 'Enviado',
        rejectedBySponsor: 'Rechazado',
        approvedBySponsor: 'Radicado',
        error: 'Error'
    },
    filters: {
        status: 'Estado',
        sponsor: 'Aseguradora',
        from: 'Desde',
        to: 'Hasta',
        searchCode: 'Buscar por ID',
        dateRange: 'Rango de fechas',
    },
    settlementGrid: {
        code: 'ID Radicación',
        createdAt: 'Fecha de creación',
        sponsor: 'Aseguradora',
        amount: 'Monto a cobrar',
        authorizations: 'Autorizaciones',
        status: 'Estado',
        medicalAccount: "No. cuenta médica"
    },
    sponsors: {
        DO: {
            humano: 'Humano Seguros',
            universal: 'ARS Universal',
            primera: 'ARS Primera'
        }
    },
    creation: {
        success: 'Envío de manera exitosa.',
        error: 'Ocurrió un error en la creación de la radicación.'
    },
    documentation: {
        complete: "Completo",
        incomplete: "({uploaded}/{total}) Docs",
        incompleteMessage: "Documentación incompleta"
    },
    documentType: {
        invoiceFile: "Documento de factura",
        creditNoteFile: "Nota de crédito",
        debitNoteFile: "Nota de débito"
    }
}
